var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapsible-panel-simple",class:_vm.isOpenModifier},[_c('h3',{staticClass:"collapsible-panel-simple__header",on:{"click":_vm.toggle}},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.isOpenState)?_c('div',{staticClass:"collapsible-panel-simple__content"},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bc600f5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/collapsible-panel/components/collapsible-panel-simple/collapsible-panel-simple.vue
// module id = cU06
// module chunks = 0